// MyAgent Core Module
// Core agent orchestration with LLM execution and tool system

import { ToolRegistry, executeCode } from 'tool_sdk'
import { createNoteTools } from 'myagent_notes/tools'
import { createNotificationToolEntries } from 'tool_sdk/tools/notification'
import { createWebTools } from 'web_tools/tools'
import { MYAGENT_BOT_ID, buildBotSystemPrompt, MYAGENT_DEFAULT_CONFIG } from './prompts.js'

export { MYAGENT_BOT_ID, buildBotSystemPrompt, MYAGENT_DEFAULT_CONFIG }
export { createToolAgent } from './tool-agent.js'

export function createBuiltinToolEntries({ getWorkerClient, notesConfig }) {
  return [
    ...createNoteTools({ getWorkerClient, notesPublicKey: notesConfig.publicKey, getTarget: notesConfig.getTarget }),
    ...createNotificationToolEntries({ getWorkerClient }),
    ...createWebTools({ getWorkerClient }),
    {
      id: 'system/executeCode',
      name: 'executeCode',
      source: 'builtin',
      description: 'Execute JavaScript for computation or math. 执行代码进行计算。',
      parameters: {
        type: 'object',
        properties: { code: { type: 'string', description: 'JavaScript code. Must return a value.' } },
        required: ['code'],
      },
      searchText: 'executeCode\nJavaScript computation math calculate arithmetic code eval\n执行代码 计算 数学运算 算术 算一下 运行代码',
      examples: [
        { input: 'calculate 15% tip on $42.50', args: { code: 'return 42.50 * 0.15' } },
        { input: 'what is 2^10', args: { code: 'return Math.pow(2, 10)' } },
        { input: '算一下 123 * 456', args: { code: 'return 123 * 456' } },
      ],
      execute: async (ctx, args) => executeCode(ctx, args),
    },
  ]
}

export async function buildToolRegistry({ embedFn, getWorkerClient, notesConfig }) {
  const registry = new ToolRegistry({ embedFn })
  registry.registerBatch(createBuiltinToolEntries({ getWorkerClient, notesConfig }))
  await registry.buildIndex()
  return registry
}
